<div style="position: relative">
  <div class="icon_images">
    <div title="Refresh" (click)="refresh()">
      <i class="pi pi-refresh" style="font-size: 1.8rem"></i>
    </div>
    <div title="Open in external tab">
      <a class="btn" [href]="url" target="_blank">
        <i class="pi pi-external-link" style="font-size: 1.8rem"></i>
      </a>
    </div>
  </div>
</div>

<div class="m-0">
  <div *ngIf="url && visible" class="iframe-wrapper">
    <div
      class="iframe-viewport"
      [ngStyle]="{
        width: (widthUnit === 'px' ? width - 50 : width) + (widthUnit || 'px'),
        height: height + (heightUnit || 'px')
      }"
    >
      <iframe
        title="Iframe Viewer"
        #iframe
        class="iframe"
        [src]="internalURL"
        [width]="width + (widthUnit || 'px')"
        [height]="height + (heightUnit || 'px')"
        sandbox="allow-same-origin allow-forms allow-modals allow-popups allow-scripts allow-downloads"
      ></iframe>
    </div>
  </div>
</div>
